<template>
  <v-container fluid grid-list-lg class="mx-0 pa-0">
  <v-layout class="" id="scrollWrapper" row wrap v-if="openedDoc !== null" >
      <v-flex>
        <v-toolbar color="cyan darken">
          <v-toolbar-title>
            {{openedDoc.titleToUse}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="closeDoc">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container id="documentDialogContent">
          <v-flex xs12>

            <v-container v-if="openedDoc.docType === 'policy'">
              <v-layout>
                <v-flex xs12 style="text-align: center;">
                  <h3 style="text-align: center;">{{openedDoc.purpose}}</h3>
                </v-flex>
              </v-layout>
              <v-container>
                <v-divider></v-divider>
              </v-container>
              <v-layout row wrap>
                <v-flex xs3 style="text-align: center;">
                  <span>{{openedDoc.num}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Policy #</b></span>
                </v-flex>
                <v-flex xs3 style="text-align: center;">
                  <span>{{openedDoc.series}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Series #</b></span>
                </v-flex>
                <v-flex xs3 style="text-align: center;">
                  <span>{{policyTypes.find(o => o.id === openedDoc.type).title}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Type</b></span>
                </v-flex>
                <v-flex xs3 style="text-align: center;">
                  <span>{{openedDoc.annualreview === 0 ? 'No' : 'Yes'}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Annual Review</b></span>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container v-if="openedDoc.docType === 'publication'">
              <v-layout>
                <v-flex xs12 style="text-align: center;">
                  <h3 style="text-align: center;">{{openedDoc.purpose}}</h3>
                </v-flex>
              </v-layout>
              <v-container>
                <v-divider></v-divider>
              </v-container>
              <v-layout row wrap>
                <v-flex xs3 style="text-align: center;">
                  <span>{{openedDoc.type}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Type</b></span>
                </v-flex>
                <v-flex xs3 style="text-align: center;">
                  <span>{{formatDate(openedDoc.dateof)}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Date</b></span>
                </v-flex>
                <v-flex xs6 style="text-align: center;">
                  <span>{{openedDoc.keywords}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Keywords</b></span>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container v-else-if="openedDoc.docType === 'school law'">
              <v-layout>
                <v-flex xs12 style="text-align: center;">
                  <h3 style="text-align: center;">{{openedDoc.description}}</h3>
                </v-flex>
              </v-layout>
              <v-container>
                <v-divider></v-divider>
              </v-container>
              <v-layout row wrap>
                <v-flex xs3 style="text-align: center;">
                  <span>{{openedDoc.chapter}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Chapter</b></span>
                </v-flex>
                <v-flex xs1 style="text-align: center;">
                  <span>{{openedDoc.revnumber}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Revision #</b></span>
                </v-flex>
                <v-flex xs2 style="text-align: center;">
                  <span>{{revisionTypes.find(o => o.id === openedDoc.revtype).title}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Revision Type</b></span>
                </v-flex>
                <v-flex xs6 style="text-align: center;">
                  <span>{{openedDoc.keywords}}</span>
                  <br/><span style="border-top: 1px solid black;"><b>Keywords</b></span>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container v-if="openedDoc.docType === 'school law'  || (openedDoc.body !== undefined && openedDoc.body !== null  && openedDoc.body.trim().length > 4)">
              <v-divider></v-divider>
            </v-container>

            <v-container v-if="openedDoc.docType === 'school law'">
              <v-flex xs12 style="text-align: center;" >
                <span><a target="_blank" :href="openedDoc.revisorurl">{{openedDoc.revisorurl}}</a></span>
                <br/><span style="border-top: 1px solid black;"><b>Revisor Url</b></span>
              </v-flex>
            </v-container>

            <v-container v-else-if="openedDoc.body !== undefined && openedDoc.body !== null  && openedDoc.body.trim().length > 4">
              <froalaView v-model="openedDoc.body"></froalaView>
            </v-container>

            <v-container>

              <v-divider></v-divider>
              <v-layout row wrap>
                <v-flex xs12 v-if="openedDoc.files && openedDoc.files.length>0">
                  <v-list class="transparent elevation-0" two-line >
                    <v-list-tile avatar ripple v-for="(item, index) in downloadableFiles"
                                 v-bind:key="index" class="grey lighten-2 mt-2 mb-2 " >
                      <v-list-item-icon>
                        <v-icon v-if="item.fileName != ''" style="margin-right: 10px;">attachment</v-icon>
                        <v-icon v-else style="margin-right: 10px;">link</v-icon>
                      </v-list-item-icon>
                      <v-list-tile-content dark >
                        <v-list-tile-title class="heading blue--text"><a @click.prevent="downloadFile(item)" :href="item.link">{{ item.name }}</a>

                        </v-list-tile-title>
                        <v-list-tile-sub-title class="grey--text text--darken-4">{{ item.fileName}}</v-list-tile-sub-title>

                      </v-list-tile-content>
                      <v-list-tile-action>

                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>

          </v-flex>
        </v-container>

      </v-flex>
  </v-layout>
  </v-container>

</template>
<script>
  import moment from "moment";

  export default {
    name: 'ViewDocument',
    data () {
      return {
        resourceTypes: ["Form", "Resolution", "Model Agreement", "Informational Resource", "Sample Document"],
        publicationTypes: ["Leader", "Journal", "Weekly Advocate", "MSBA Advocate"],
        revisionTypes: [{title: "Statute", id: 'S'}, {title: "Law", id: 'L'}, {title: "Rule", id: 'R'}],
        policyTypes: [{title: "Mandatory", id: 'M'}, {title: "Legislative", id: 'L'}, {title: "Recommended", id: 'R'}],
        dialogOpen: true,
        openedDoc: true,
      }
    },
    components: {
    },
    methods: {
       inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },
      downloadFile(item) {
        if(this.inIframe()) {
          this.$sendMessageToParent('fileDownload', {'url': item.link})
        } else {
          try {
            window.open(item.link, '_blank');
          } catch {
            window.location.href = item.link
          }
        }
      },
      formatDate (date) {
        return date ? moment(date).format('MM/DD/YYYY') : ''
      },
      openDoc(doc) {
        doc.docType = this.$route.params.type;
        if(doc.docType == 'servicemanual')
        doc.docType = "school law"

        doc.titleToUse = (doc.docType !== 'school law' ? doc.title : ('#' + doc.revnumber + ' - ' + doc.chapter ))

        if (!Array.isArray(doc.files)) {
          doc.files = JSON.parse(doc.files)
        }

        console.log('opening doc', doc)

        this.openedDoc = doc

        this.$sendMessageToParent('docOpen', { 'url': this.$route.path, 'title': this.openedDoc.titleToUse })
        ///send message

      },
      closeDoc() {
        this.dialog = false;
        this.$sendLogEntry({
          documentTitle: this.openedDoc.title,
          documentLink: this.$router.resolve({name: 'ViewDocument', params: {type: this.openedDoc.docType.toLowerCase(), id: this.openedDoc.id}}).href,
          'eventType' : 'close'
        })
        this.$router.push({name: 'Search'})
        this.$sendMessageToParent('docClose')
      },
      calculateHeight() {
        let newHeight = null
        if (this.openedDoc == null && document.getElementById("scrollWrapper") != undefined)
          newHeight = document.getElementById("scrollWrapper").scrollHeight
        else if (document.getElementById("documentDialogContent") != undefined)
          newHeight = document.getElementById("documentDialogContent").scrollHeight + 75
        //newHeight = document.getElementsByClassName("documentDialog")[0].scrollHeight

        if(newHeight != this.pageHeight) {
          console.log('height changed', newHeight)
          let message = JSON.stringify({
            event: 'height',
            data: newHeight,
          });
          window.parent.postMessage(message, '*');
          this.pageHeight = newHeight
        }
      },
      redirectToLogin() {
        //window.location.replace("https://dev1.mnmsba.org/login?redirectTo=" + window.location.href);

        console.log('in redirectToLogin')

        try {
          top.location.replace("https://mnmsba.org/login?redirectTo=" + top.location.href);
        } catch (error) {
          console.log('calling parent login')
          let message = JSON.stringify({
            event: 'login',
            document: this.$route.path
          });
          window.parent.postMessage(message, '*');
        }




       // window.location.replace("https://mnmsba.org/login?redirectTo=" + window.location.href);
      }
    },
    computed: {
      loggedIn() {
        let userData = this.$checkUserdata()

        console.log('checking login',userData)
        return !(userData == undefined || userData.email == undefined)
      },
      downloadableFiles(){
        let toReturn = []
        if(this.openedDoc.files && this.openedDoc.files.length > 0) {
          this.openedDoc.files.forEach((file)=>{
            console.log('checking file', file)

            if(file.link.indexOf('-download-') == -1) {

              console.log('changing file link to new')

              let fileParts = file.link.split('/')

              file.link = "https://search.mnmsba.org/api/download/" + fileParts[fileParts.length - 2] + '-download-' + fileParts[fileParts.length - 1]

            }

            toReturn.push(file)
          })
        }
        return toReturn
      }
    },
    mounted () {
      let vueThis = this
      console.log('MOUNTED VIEW DOCUMENT', this.$route.params.type)

      if(this.$route.params.type.includes('policy')) {
        this.$route.params.type = 'policy'
      }

      this.calculateHeight()

      setInterval(this.calculateHeight,250);

      if(this.$dataLoaded) {
        console.log('data already loaded')
        let doc = this.$getDocument(this.$route.params.id)
        console.log('data ',doc)
        if(doc.publicvisible == true) {
          console.log('public doc skip login check')
          this.openDoc(doc)
        } else if(!this.loggedIn) {
          console.log('going to call redirectToLogin')
          this.redirectToLogin(doc)
        } else if(doc.body == undefined) {
          this.$router.push({name: 'PermissionDenied'})
        } else {
          this.openDoc(doc)
        }
      }
      this.$services[this.$getFeatherEndpoint({docType:this.$route.params.type})].get(this.$route.params.id
      ).then((result) => {
        console.log('got data',result)

        if(result.publicvisible == true) {
          console.log('public doc skip login check')
          this.openDoc(result)
        } else if(!vueThis.loggedIn) {
          console.log('2 going to call redirectToLogin')
          this.redirectToLogin()
        } else if(result.body == undefined) {
          this.$router.push({name: 'PermissionDenied'})
        } else {
          this.openDoc(result)
        }
      })
    }
  }
</script>
